var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiCurrencyItem4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 62,
    viewBox: "0 0 75 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 5.40697C10.1992 2.42078 12.6122 0 15.5888 0H59.1097C62.0863 0 64.4992 2.42079 64.4992 5.40698V29.5057C64.4992 32.4919 62.0862 34.9126 59.1097 34.9126H15.5887C12.6122 34.9126 10.1992 32.4918 10.1992 29.5057V5.40697Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -30,
    y: -22.1748,
    width: 135,
    height: 114.175
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#bgblur_0_974_11213_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 30,
    d: "M75 22.4969C75 17.5199 70.9784 13.4852 66.0174 13.4852H42.2308C40.2361 13.4852 38.3974 12.4025 37.425 10.6552C36.4526 8.90792 34.6139 7.8252 32.6192 7.8252H8.98256C4.02163 7.8252 0 11.8598 0 16.8368V52.9883C0 57.9653 4.02163 62 8.98256 62H66.0174C70.9784 62 75 57.9653 75 52.9883V22.4969Z",
    fill: "url(#paint0_linear_974_11213)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -30,
    y: -22.1748,
    width: 135,
    height: 114.175
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#bgblur_1_974_11213_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 30
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0174 13.6655H42.2308C40.1709 13.6655 38.2723 12.5474 37.2681 10.7431C36.3275 9.05281 34.5488 8.00543 32.6192 8.00543H8.98256C4.12085 8.00543 0.179651 11.9594 0.179651 16.8368V52.9883C0.179651 57.8658 4.12085 61.8197 8.98256 61.8197H66.0174C70.8792 61.8197 74.8204 57.8658 74.8204 52.9883V22.4969C74.8204 17.6194 70.8791 13.6655 66.0174 13.6655ZM66.0174 13.4852C70.9784 13.4852 75 17.5199 75 22.4969V52.9883C75 57.9653 70.9784 62 66.0174 62H8.98256C4.02163 62 0 57.9653 0 52.9883V16.8368C0 11.8598 4.02163 7.8252 8.98256 7.8252H32.6192C34.6139 7.8252 36.4526 8.90792 37.425 10.6552C38.3974 12.4025 40.2361 13.4852 42.2308 13.4852H66.0174Z",
    fill: "url(#paint1_linear_974_11213)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0174 13.6655H42.2308C40.1709 13.6655 38.2723 12.5474 37.2681 10.7431C36.3275 9.05281 34.5488 8.00543 32.6192 8.00543H8.98256C4.12085 8.00543 0.179651 11.9594 0.179651 16.8368V52.9883C0.179651 57.8658 4.12085 61.8197 8.98256 61.8197H66.0174C70.8792 61.8197 74.8204 57.8658 74.8204 52.9883V22.4969C74.8204 17.6194 70.8791 13.6655 66.0174 13.6655ZM66.0174 13.4852C70.9784 13.4852 75 17.5199 75 22.4969V52.9883C75 57.9653 70.9784 62 66.0174 62H8.98256C4.02163 62 0 57.9653 0 52.9883V16.8368C0 11.8598 4.02163 7.8252 8.98256 7.8252H32.6192C34.6139 7.8252 36.4526 8.90792 37.425 10.6552C38.3974 12.4025 40.2361 13.4852 42.2308 13.4852H66.0174Z",
    fill: "url(#paint2_radial_974_11213)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_974_11213_clip_path",
    transform: "translate(30 22.1748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 22.4969C75 17.5199 70.9784 13.4852 66.0174 13.4852H42.2308C40.2361 13.4852 38.3974 12.4025 37.425 10.6552C36.4526 8.90792 34.6139 7.8252 32.6192 7.8252H8.98256C4.02163 7.8252 0 11.8598 0 16.8368V52.9883C0 57.9653 4.02163 62 8.98256 62H66.0174C70.9784 62 75 57.9653 75 52.9883V22.4969Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_974_11213_clip_path",
    transform: "translate(30 22.1748)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0174 13.6655H42.2308C40.1709 13.6655 38.2723 12.5474 37.2681 10.7431C36.3275 9.05281 34.5488 8.00543 32.6192 8.00543H8.98256C4.12085 8.00543 0.179651 11.9594 0.179651 16.8368V52.9883C0.179651 57.8658 4.12085 61.8197 8.98256 61.8197H66.0174C70.8792 61.8197 74.8204 57.8658 74.8204 52.9883V22.4969C74.8204 17.6194 70.8791 13.6655 66.0174 13.6655ZM66.0174 13.4852C70.9784 13.4852 75 17.5199 75 22.4969V52.9883C75 57.9653 70.9784 62 66.0174 62H8.98256C4.02163 62 0 57.9653 0 52.9883V16.8368C0 11.8598 4.02163 7.8252 8.98256 7.8252H32.6192C34.6139 7.8252 36.4526 8.90792 37.425 10.6552C38.3974 12.4025 40.2361 13.4852 42.2308 13.4852H66.0174Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_974_11213",
    x1: 8.02583,
    y1: 12.8235,
    x2: 75.8375,
    y2: 61.4328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A81FF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#567DFF",
    stopOpacity: 0.955296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E78FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_974_11213",
    x1: 10.7934,
    y1: 5.89038,
    x2: 67.8076,
    y2: 51.9753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_974_11213",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(37.0849 -33.0531 45.7589 69.7032 11.2085 60.2264)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiCurrencyItem4);
export default __webpack_public_path__ + "static/media/multi_currency_item4.5026883e0ab26ad09ee6843637fe37f1.svg";
export { ForwardRef as ReactComponent };